import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import InvoiceFilter from './InvoiceFilter';
import DatePicker from 'react-datepicker';
import CustomerInvoices from './CustomerInvoices';
import moment from 'moment';
import GroupedInvoiceList from './GroupedInvoiceList';

export default class GroupedInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            month: moment().startOf('month').toDate(),
            invoices: [],
            loading: null,
        };
    }

    componentDidMount() {
        this.loadInvoicesFromServer();
    }

    loadInvoicesFromServer() {
        $.ajax({
            url: this.props.url,
            data: { month: moment(this.state.month).format('YYYY/MM/DD') },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    invoices: data.invoices,
                });
            },

            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    handleDateChange = (month) => {
        this.setState(
            {
                month: month,
            },
            () => {
                this.loadInvoicesFromServer();
            }
        );
    };

    handlePoChange = (e, identifier) => {
        let value = e.target.value;

        let invoices = [...this.state.invoices];

        let invoice = invoices.find((invoice) => {
            return invoice.invoice_identifier === identifier;
        });

        invoice.po_number = value;

        this.setState({
            invoices: invoices,
        });
    };

    savePoNumber = (identifier) => {
        this.setState({
            loading: identifier,
        });

        let invoice = this.state.invoices.find((invoice) => {
            return invoice.invoice_identifier === identifier;
        });

        $.ajax({
            url: this.props.savePOUrl,
            data: { identifier: identifier, po_number: invoice.po_number },
            dataType: 'json',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            success: (data) => {
                toastr.success('PO Number successfully Saved');
                this.setState({
                    loading: null,
                });
            },
            error: (xhr, status, err) => {
                toastr.error('There was a problem, please try again');
                this.setState({
                    loading: null,
                });
            },
        });
    };

    render() {
        return (
            <div>
                <div className="row pt-4">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="text-white py-2 pl-2">Grouped Invoices for month</h6>
                            </div>
                            <div className="pr-2 w-25">
                                <DatePicker
                                    selected={this.state.month}
                                    onChange={(month) => this.handleDateChange(month)}
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Select month"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <GroupedInvoiceList
                        invoices={this.state.invoices}
                        downloadUrl={this.props.downloadUrl}
                        onPoChange={this.handlePoChange}
                        savePoNumber={this.savePoNumber}
                        loading={this.state.loading}
                    />
                </div>
            </div>
        );
    }
}

if (document.getElementById('grouped-invoices')) {
    let element = document.getElementById('grouped-invoices');

    ReactDOM.render(
        <GroupedInvoices
            url={element.dataset.url}
            downloadUrl={element.dataset.download_url}
            savePOUrl={element.dataset.po_url}
        />,
        element
    );
}
